export default __webpack_public_path__ + "static/media/whatsapp-icon.76190a9c.svg";